import React from 'react'
import { Box, Button, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { saveToLocalStorage } from '@/shared/localStorage/localStorageRepository'
import { IS_COOKIES_ACCEPTED } from '@/shared/constants'
import { useAppStore } from '@/shared/store'
import { Link } from 'react-router-dom'

const backdropStyle: React.CSSProperties = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 'max-content',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
}

const modalStyle: React.CSSProperties = {
    maxWidth: '50%',
    position: 'relative',
    borderRadius: '10px',
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '15px',
    zIndex: 8,
}

const buttonCloseStyle = {
    cursor: 'pointer',
    position: 'absolute',
    right: '0px',
    top: '0',
    width: '32px',
    height: '32px',
    fontSize: '16px',
    zIndex: 9,
}

const button = {
    width: '80px',
}

interface ModalLoaderProps {
    open: boolean
    handleClose: () => void
}

const CookiesModal: React.FC<ModalLoaderProps> = ({ open, handleClose }) => {
    const { t: translate } = useTranslation()
    const theme = useTheme()
    const modalHeader = translate('cookiesHeader')
    const modalText = translate('cookies')
    const { setIsCookiesAccepted, tAndC } = useAppStore()
    if (!open) return null
    const handleDeclineCookies = () => {
        setIsCookiesAccepted(false)
        saveToLocalStorage(IS_COOKIES_ACCEPTED, '')
        handleClose()
    }
    const handleAcceptCookies = () => {
        setIsCookiesAccepted(true)
        saveToLocalStorage(IS_COOKIES_ACCEPTED, 'true')
        handleClose()
    }
    const buttonHover = {
        '&:hover': {
            color: 'black',
            backgroundColor: theme.palette.primary.main,
        },
    }
    const border = {
        border: `1px solid ${theme.palette.primary.main}`,
    }
    return (
        <Box style={backdropStyle} onClick={handleClose}>
            <Box
                style={modalStyle}
                onClick={(event) => event.stopPropagation()}>
                <Box display="flex" gap="20px" flexDirection="column">
                    <Typography>{modalHeader}</Typography>
                    <Typography>
                        {modalText}{' '}
                        <Link
                            to={tAndC}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                                color: `${theme.palette.primary.main}`,
                            }}>
                            Privacy Policy.
                        </Link>
                    </Typography>
                </Box>
                <Box
                    display="flex"
                    justifyContent="end"
                    gap="20px"
                    width="100%">
                    <Button
                        sx={{ ...button, ...buttonHover }}
                        onClick={handleDeclineCookies}>
                        {translate('decline')}
                    </Button>
                    <Button
                        sx={{ ...button, ...buttonHover, ...border }}
                        onClick={handleAcceptCookies}>
                        {translate('accepting')}
                    </Button>
                </Box>
            </Box>
            <Button sx={buttonCloseStyle} onClick={handleClose}>
                x
            </Button>
        </Box>
    )
}

export default CookiesModal
